import React, { Component } from "react";
import { connect } from "react-redux";
import "./SubmitButton.component.scss";
import { SubmitButtonStrings } from "./SubmitButton.strings";
import {authStoreSelectors} from "../../../../store/store";

export interface SubmitButtonNewAccountProps {
    onChangePage: any;
}

class SubmitButtonNewAccount extends Component<SubmitButtonNewAccountProps, {}> {



    render() {
        let message = SubmitButtonStrings.CREATE;

        return (
            <div id="SubmitButtonNewAccount">
                <button
                    type="button"
                    onClick={() => this.props.onChangePage(1)}
                    className="grey-btn-negative">
                    {message}
                </button>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    redirectLogin: authStoreSelectors.redirectLogin(state)
});

export default connect(
    mapStateToProps,
    null
)(SubmitButtonNewAccount);
